import { ContractType } from "data/store/TokenStore";

const GF_ABI = [
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "balance",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];

export const GF_CONTRACT: ContractType = {
  address: "0xaaef88cea01475125522e117bfe45cf32044e238",
  unit: "ether",
  abi: GF_ABI,
};
